module.exports = __webpack_public_path__ + "static/media/白洋医疗授权资质.49b3022a.jpg";